import React from 'react';

interface OrganizationBranding {
  logoUrl?: string;
  primaryColor?: string;
  secondaryColor?: string;
}

interface LogoProps {
  className?: string;
  variant?: 'full' | 'icon';
  organizationName?: string;
  branding?: OrganizationBranding;
}

const DEFAULT_ICON = '/icons/ServiceLineIcon.png';

export const Logo: React.FC<LogoProps> = ({
  className = '',
  variant = 'full',
  organizationName = 'EU ServiceLine',
  branding
}) => {
  const hasCustomLogo = branding?.logoUrl;
  if (variant === 'icon') {
    return (
      <img
        src={hasCustomLogo ? branding!.logoUrl : DEFAULT_ICON}
        alt={`${organizationName} logo`}
        className={`h-8 w-8 object-contain ${className}`}
        onError={(e) => {
          e.currentTarget.style.display = 'none';
        }}
      />
    );
  }

  return (
    <div className={hasCustomLogo ? 'flex items-center' : `flex items-center ${className}`}>
      {hasCustomLogo ? (
        <img
          src={branding!.logoUrl}
          alt={`${organizationName} logo`}
          className={`w-auto object-contain ${className}`}
          onError={(e) => {
            e.currentTarget.style.display = 'none';
          }}
        />
      ) : (
        <>
          <img
            src={DEFAULT_ICON}
            alt={`${organizationName} logo`}
            className="h-9 w-9 object-contain mr-3"
          />
          <div className="flex flex-col">
            <span className="text-xl font-bold text-gray-900 dark:text-white leading-tight">
              {organizationName}
            </span>
            <span className="text-xs text-gray-600 dark:text-gray-400 -mt-0.5">
              Customer Support Platform
            </span>
          </div>
        </>
      )}
    </div>
  );
};
